import React from 'react';
import Seo from '../components/Seo';

function FeriasEventos() {
  return (
    <div className="page editorial-index">
      <Seo title="Ferias y eventos" description="Ferias, presentaciones, firmas, festivales y encuentros editoriales." />
      <header className="editorial-index__header">
        <span className="eyebrow">Agenda literaria</span>
        <h1>Ferias y eventos</h1>
        <p className="page__intro">Ferias, presentaciones, firmas, festivales y encuentros editoriales.</p>
      </header>
      <div className="editorial-empty" role="status">
        <span className="editorial-empty__ornament" aria-hidden="true">✦</span>
        <p className="editorial-empty__title">La próxima cita está por escribirse.</p>
        <p>Pronto compartiremos aquí encuentros y experiencias alrededor de los libros.</p>
      </div>
    </div>
  );
}

export default FeriasEventos;
